<script setup>
import {ElCol, ElRow} from 'element-plus';
import 'element-plus/es/components/col/style/css';
import 'element-plus/es/components/row/style/css';
</script>
<template>
  <el-row type="flex" justify="center">
    <el-col class="wrapper__col" :xs="24" :sm="22" :md="20" :lg="18">
      <slot></slot>
    </el-col>
  </el-row>
</template>

<script>
  const wrapper = {
    name: "DpWrapper"
  };

  export default wrapper;
</script>

<style>
  .wrapper__col {
    max-width: 1200px;
  }

  @media only screen and (max-width: 767px) {
    .wrapper__col {
      padding: 0 1rem;
    }
  }

</style>
